import { CHORE_SEED_GROUPS } from '../../../../../shared/chores-seeds';

/** Seed library (card VmoORelj1HuO): forty common chores, grouped,
 *  multi-pick — tap several, add them together. */
export function SeedLibrary({ picked, setPicked, toggleSeed, addSeeds, adding }: {
  picked: string[];
  setPicked: (p: string[]) => void;
  toggleSeed: (seed: string) => void;
  addSeeds: () => Promise<void>;
  adding: boolean;
}) {
  return (
    <div className="rq-card ch-seed-card" id="ch-seed-library">
      <div className="ch-seed-head">
        <span className="rq-composer-label">Common ones</span>
        <span className="rq-empty-hint ch-seed-count" id="ch-seed-count" role="status">
          {picked.length === 0 ? 'Tap a few, then add them together.' : `${picked.length} picked`}
        </span>
        {picked.length > 0 && (
          <button type="button" id="ch-seed-clear" className="pear-btn ch-seed-clear" onClick={() => setPicked([])}>
            Clear
          </button>
        )}
      </div>
      <div className="ch-seeds" role="group" aria-label="Common ones">
        {CHORE_SEED_GROUPS.map(group => (
          <div className="ch-seed-group" key={group.group}>
            <span className="ch-seed-group-label">{group.group}</span>
            <div className="ch-seed-group-items">
              {group.titles.map(seed => (
                <button
                  key={seed}
                  type="button"
                  aria-pressed={picked.includes(seed)}
                  className={`underline-select ch-seed${picked.includes(seed) ? ' is-on' : ''}`}
                  onClick={() => toggleSeed(seed)}
                >
                  {seed}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      <button
        type="button"
        id="ch-seed-add"
        className="pear-btn pear-btn-mustard ch-seed-add"
        disabled={picked.length === 0 || adding}
        onClick={() => void addSeeds()}
      >
        {adding ? 'Adding…' : picked.length > 0 ? `Add ${picked.length}` : 'Add'}
      </button>
    </div>
  );
}
